import { ACTION_BOUND } from "mobx/dist/internal";
import { createContext, useContext, useReducer } from "react";

export const ToastContext = createContext({
  toasts: [],
  placement: "",
});
export const ToastDispatchContext = createContext(null);

const ToastReducer = (state, action) => {
  switch (action.type) {
    case "ADD_TOAST": {
      return {
        ...state,
        toasts: [...state.toasts, action.toast],
        placement: action.placement,
      };
    }
    case "DELETE_TOAST": {
      const updatedTosts = state.toasts.filter((item) => item.id !== action.id);
      return {
        ...state,
        toasts: state.toasts.filter((item) => item.id !== action.id),
      };
    }
    default: {
      throw new Error("Incorrect Action");
    }
  }
};

export const ToastProvider = ({ children }) => {
  const [state, dispatch] = useReducer(ToastReducer, {
    toasts: [],
    placement: "",
  });

  return (
    <ToastContext.Provider value={state}>
      <ToastDispatchContext.Provider value={dispatch}>
        {children}
      </ToastDispatchContext.Provider>
    </ToastContext.Provider>
  );
};

export const useToastStateContext = () => useContext(ToastContext);
export const useToastDispatchContext = () => useContext(ToastDispatchContext);
